// JOBE-0044.14: Cedar-denied variant. Same shape as cold-start, with
// the normative copy from ADR-0023 §D6 appended: "Permissions missing
// — ask an admin to install the entity overlay." No URN disclosure;
// no count surface (R10 silent-drop posture).

export function CedarDeniedState() {
  return (
    <div
      className="library-table-empty library-state-cedar-denied"
      data-state="cedar-denied"
    >
      <p className="library-state-empty-headline">Nothing yet.</p>
      <p className="library-state-empty-body">
        Permissions missing — ask an admin to install the entity overlay.
      </p>
    </div>
  );
}
